import { PurchaseRequestSkuVariant } from "../../../models/PurchaseRequest/PurchaseRequestProductRequestBody";
import {
  StockIssueRequestBody,
  StockIssueRequestOrderProductMappingBody,
  StockIssueRequestProductBody,
} from "../../../models/StockIssueRequest/StockIssueRequestBody";
import {
  isPurchaseRequestSkuVariantSelected,
  isValidStockIssueRequestSkuVariant,
} from "../../../utils/purchaseRequestSkuVariants";

export interface StockIssueRequestLineProduct {
  id: number;
  cost_price?: number;
  unit_price?: number;
  selling_price?: number;
  product_selling_price?: number;
  gst_percentage?: number;
  description?: string;
  desc?: string;
}

export function buildStockIssueRequestBody(params: {
  orderId: number;
  warehouseId: string;
  products: StockIssueRequestLineProduct[];
  selectedSkuVariants: Map<number, PurchaseRequestSkuVariant[]>;
}): StockIssueRequestBody | null {
  const orderProductsMapping: StockIssueRequestOrderProductMappingBody[] = [];
  const productsMap = new Map<number, StockIssueRequestProductBody>();

  params.products.forEach((product) => {
    const productSkuVariants = (
      params.selectedSkuVariants.get(product.id) || []
    ).filter(isValidStockIssueRequestSkuVariant);

    if (productSkuVariants.length === 0) {
      return;
    }

    const rate =
      product.cost_price ||
      product.unit_price ||
      product.selling_price ||
      product.product_selling_price ||
      1;
    const gstPercentage = product.gst_percentage || 18;

    if (!productsMap.has(product.id)) {
      productsMap.set(product.id, {
        product_id: product.id,
        rate,
        gst_percentage: gstPercentage,
      });
    }

    productSkuVariants.forEach((variant) => {
      orderProductsMapping.push({
        order_id: params.orderId,
        product_id: product.id,
        quantity: variant.quantity,
        sku: variant.sku,
        description: product.description?.trim() || undefined,
      });
    });
  });

  if (orderProductsMapping.length === 0) {
    return null;
  }

  return {
    warehouse_id: params.warehouseId,
    products: Array.from(productsMap.values()),
    order_products_mapping: orderProductsMapping,
  };
}

export function hasSelectedStockIssueSkuVariants(
  productId: number,
  selectedSkuVariants: Map<number, PurchaseRequestSkuVariant[]>,
): boolean {
  return (selectedSkuVariants.get(productId) || []).some(
    (variant) =>
      isPurchaseRequestSkuVariantSelected(variant) &&
      Number(variant.quantity) > 0,
  );
}
